// Central data-testid registry
export const TID = {
  navHome: "nav-home",
  navSubmit: "nav-submit-link",
  navDashboard: "nav-admin-dashboard",
  navMyLinks: "nav-my-links",
  navLogin: "nav-login",
  navRegister: "nav-register",
  navLogout: "nav-logout",
  heroCta: "hero-cta-button",
  categoryCard: "category-card",
  dealCard: "deal-card",
  dealVisitBtn: "deal-visit-button",
  chatToggle: "ai-chat-toggle",
  chatInput: "ai-chat-input",
  chatSend: "ai-chat-send",
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerName: "register-name-input",
  registerSubmit: "register-submit-button",
  submitTitle: "submit-title-input",
  submitUrl: "submit-url-input",
  submitPrice: "submit-price-input",
  submitDescription: "submit-description-input",
  submitCategory: "submit-category-select",
  submitImageFile: "submit-image-file",
  submitImageUrl: "submit-image-url-input",
  tierCard: "pricing-tier-card",
  submitPayBtn: "submit-pay-button",
};
